import "./Card.css";

function Card({ link, image, heading, description }) {
  const backend = process.env.REACT_APP_BACKEND_LINK;
  const imgSrc  = image
    ? image.startsWith("http") ? image : `${backend.replace(/\/$/, "")}${image}`
    : null;

  return (
    <div className="card">
      <div className="card__image">
        {imgSrc ? (
          <img src={imgSrc} alt={heading} />
        ) : (
          <div style={{ width: "100%", height: "100%", background: "var(--color-placeholder)" }} />
        )}
      </div>
      <div className="card__body">
        <h4 className="card__title">{heading}</h4>
        <p className="card__desc">{description}</p>
        <a className="card__btn" href={`/case/${link}`} target="_blank" rel="noreferrer">
          Read
        </a>
      </div>
    </div>
  );
}

export default Card;
